import React from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { utilMethods } from '../../util/util.js';
import TowSheetDays from './TowSheetDays';
import { tokens } from '../../theme';

const TowSheetCard = ({ invNo, attachmentURL }) => (
    <ButtonBase
        onClick={() => attachmentURL && window.open(attachmentURL)}
        disabled={!attachmentURL}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            p: 2,
            borderRadius: 1.5,
            border: `1px solid ${tokens.line}`,
            bgcolor: 'background.paper',
            '&:hover': { borderColor: tokens.blue },
            '&:focus-visible': { outline: `2px solid ${tokens.blue}` },
        }}
    >
        <PictureAsPdfOutlinedIcon sx={{ fontSize: 36, color: attachmentURL ? tokens.red : 'text.disabled' }} />
        <Typography sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums', color: attachmentURL ? tokens.blue : 'text.secondary' }}>
            {invNo}
        </Typography>
    </ButtonBase>
);

const InvoiceThumbView = ({ invoiceList }) => (
    <TowSheetDays
        invoiceList={invoiceList}
        renderDay={(attachments) => (
            <Box sx={{ display: 'grid', gap: 1.5, gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))' }}>
                {utilMethods.sortInvoiceArray(Object.keys(attachments)).map((item) => {
                    const files = attachments[item.invNo] || [];
                    return <TowSheetCard key={item.invNo} invNo={item.invNo} attachmentURL={files.length ? files[0].attachmentURL : null} />;
                })}
            </Box>
        )}
    />
);

export default InvoiceThumbView;
